import { ArpMedia } from '@arpeggi/shared'
import { createContext, useContext } from 'react'
import { Status } from '../../../__legacy__/components/core/Utils'
import { ArpMediaFilters } from '../hooks'

export interface ArpTableContextData<F = ArpMediaFilters> {
  nextPage: () => any
  updateFilters: (filter: Partial<F>) => void
  hasMore: boolean
  data: ArpMedia[]
  filters: F
  defaultFilters: F
  status: Status
}

export const ArpTableContext = createContext<ArpTableContextData>(null)

export const useArpTableContext = () => useContext(ArpTableContext)
